import Button from "@pathwright/ui/src/components/button/Button"
import CardBack from "@pathwright/ui/src/components/card/CardBack"
import Link from "@pathwright/ui/src/components/link/Link"
import AnimatedIcon from "@pathwright/ui/src/components/pathicon/AnimatedIcon"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import Text from "@pathwright/ui/src/components/ui/Text"
import withTranslate from "@pathwright/ux/src/components/lng/withTranslate"
import pluralize from "pluralize"
import { Component } from "react"
import styled from "styled-components"
import { withPathwrightContext } from "../../pathwright/PathwrightContext"
import { getSwitchSpaceLink } from "../../space/switcher/SpaceSwitcher"
import {
  LICENSING_MODE_GROUP_SUBSCRIPTION,
  LICENSING_MODE_SCHOOL_LICENSING
} from "../../store/resource/offering/license/constants"
import { getGroupUrl, getStoreUrl } from "../../utils/urls"

const tPrefix = "resource.license_success"

const Container = styled.div`
  text-align: center;
  padding: 40px 60px;
  display: flex;
  flex-direction: column;
  align-items: center;

  a {
    border-bottom: 1px solid;
  }
`

const Footer = styled.footer`
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  .Button {
    margin-bottom: 5px;
  }
`

class LicenseResourceSuccess extends Component {
  componentDidMount() {
    this.props.onLicenseSuccess &&
      this.props.onLicenseSuccess(this.props.license)

    // HACK: bootstrapping the store will ensure the
    // window.bootstrappedData.permissions.user_is_teaching flag will be updated
    window.App && window.App.getStore("school").action.bootstrapSchool()
  }

  render() {
    const { t, Trans } = this.props

    const schoolIsLicensee =
      this.props.context.school.id === this.props.licenseeSchool.id

    return (
      <Container>
        {!!this.props.card && <CardBack card={this.props.card} />}
        <AnimatedIcon icon="check" brand />
        <Text.H3 style={{ margin: "10px 0" }}>
          {t(`${tPrefix}.resource_ready_to_teach`, {
            resource_name: this.props.license_offering.resource.name
          })}
        </Text.H3>
        {this.props.license_offering.licensing_mode ===
        LICENSING_MODE_SCHOOL_LICENSING ? (
          <Text.Body>
            {t(`${tPrefix}.resource_ready_to_offer`)},{" "}
            {this.props.licenseeSchool.name}
          </Text.Body>
        ) : (
          <Text.Body>
            {this.props.license.seats_available == 0 ||
            this.props.license_offering.licensing_mode ===
              LICENSING_MODE_GROUP_SUBSCRIPTION ? (
              // prettier-ignore
              // Trans formatting integral to translation json!
              <Trans
                i18nKey={`${tPrefix}.resource_ready_to_take`}
                parent="span"
              >
                Congratulations, you're ready to start taking{" "}
                {{ resource_name: this.props.license_offering.resource.name }}{" "}
                with your own group.
              </Trans>
            ) : (
              // prettier-ignore
              // Trans formatting integral to translation json!
              <Trans
                i18nKey={`${tPrefix}.resource_ready_to_take_with`}
                parent="span"
              >
                Congratulations, you're ready to start taking{" "}
                {{ resource_name: this.props.license_offering.resource.name }}{" "}
                with up to{" "}
                {{ people_count: this.props.license.seats_available }}{" "}
                {{
                  people: t(
                    `${tPrefix}.${pluralize(
                      "person",
                      this.props.license.seats_available
                    )}`
                  )
                }}{" "}
                of your choice.
              </Trans>
            )}
            <br />
            <br />
            {t(`${tPrefix}.email_confirmation`)}
          </Text.Body>
        )}
        {this.props.license_offering.licensing_mode ===
        LICENSING_MODE_SCHOOL_LICENSING ? (
          schoolIsLicensee ? (
            <Footer>
              <Button styleType="primary" size="large" to="/home/teach/">
                {t(`${tPrefix}.done`)}
              </Button>
              <Text.Meta>
                {t(`${tPrefix}.go_directly`)}{" "}
                <Link
                  to={getGroupUrl(
                    this.props.license.group.resource.slug,
                    this.props.license.group.id
                  )}
                >
                  {t(`${tPrefix}.the_course`)}
                </Link>
                .
              </Text.Meta>
            </Footer>
          ) : (
            <Footer>
              <Button
                styleType="primary"
                size="large"
                href={getSwitchSpaceLink(this.props.licenseeSchool.id)}
              >
                {t(`${tPrefix}.go_to_course`)}
              </Button>
              <Text.Meta>
                {/* prettier-ignore */}
                {/* Trans formatting integral to translation json! */}
                <Trans i18nKey={`${tPrefix}.continue_browsing`} parent="span">
                  or <Link to={getStoreUrl()}>continue browsing</Link>.
                </Trans>
              </Text.Meta>
            </Footer>
          )
        ) : (
          <Footer>
            <Button
              styleType="primary"
              size="large"
              to={getGroupUrl(
                this.props.license.group.resource.slug,
                this.props.license.group.id
              )}
            >
              {t(`${tPrefix}.get_started`)} <Pathicon icon="chevron-right" />
            </Button>
          </Footer>
        )}
      </Container>
    )
  }
}

LicenseResourceSuccess.displayName = "LicenseResourceSuccess"

export default withPathwrightContext(withTranslate(LicenseResourceSuccess))
